'use client';

import { Story } from '@/utils/types';
import Card from '@/ui/Card';
import { Eye, Heart, BookOpen } from 'lucide-react';
import { useRouter } from 'next/navigation';

interface StoryCardProps {
  story: Story;
}

export default function StoryCard({ story }: StoryCardProps) {
  const router = useRouter();

  const handleClick = () => {
    router.push(`/story/${story._id}`);
  };

  return (
    <Card onClick={handleClick} className="overflow-hidden h-full hover:border-primary/50 transition-colors group">
      <div className="relative w-full aspect-video overflow-hidden bg-accent">
        <img
          src={story.thumbnail}
          alt={story.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-2 right-2 bg-black/80 backdrop-blur-sm text-white px-2 py-1 rounded text-xs font-medium">
          {story.genre}
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-base font-bold mb-1 line-clamp-2 text-foreground group-hover:text-primary transition-colors">
          {story.title}
        </h3>
        <p className="text-xs text-muted mb-2">
          Written by {story.author}
        </p>
        <p className="text-xs text-muted/80 mb-3 line-clamp-2 leading-relaxed">
          {story.description}
        </p>
      </div>
    </Card>
  );
}
